import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import ls from "local-storage"; // This only needs to be imported once in your app

toast.configure();
const axios = require("axios");

class Weeklyadsall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      WeeklyAds: null,
      adindex: 0,
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.GetWeeklyAds();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    this.GetWeeklyAds();
    ls.set("redirectTo", window.location.href);
  }

  convertDate(dt) {
    //var dt = '/Date(1567494000000+0000)/'
    var dt2 = dt.substr(dt.indexOf("(") + 1);
    var dt3 = dt2.substr(0, dt2.indexOf("+"));
    var d = new Date(Number(dt3));
    //console.log(dt, dt3, d);
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = d.getFullYear();
    var dt4 = mm + "/" + dd + "/" + yyyy;
    return dt4;
  }

  GetWeeklyAds() {
    let StoreID = this.props.match.params.id;
    let store_name = this.props.match.params.store;
    let store = null;
    if (StoreID !== "") {
      this.setState({ store: store });
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN;
    var ClientStoreId = StoreID !== null && StoreID > 0 ? StoreID : 1;

    // console.log('route changes3');
    const data = new FormData();
    data.append("method", "GET");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/services/SSWebRestApi.svc/WeeklyAdGallery/${UserToken}/${ClientStoreId}`);
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/WeeklyAdGallery/${UserToken}/${ClientStoreId}`;
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);
    axios
      .get(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.GalleryItems) {
          this.setState({ WeeklyAds: res.data.GalleryItems });
        } else {
          this.setState({ WeeklyAds: [] });
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  render() {
    const images = [
      "//placekitten.com/1500/500",
      "//placekitten.com/4000/3000",
      "//placekitten.com/800/1200",
      "//placekitten.com/1500/1500",
    ];
    const { adindex, isOpen } = this.state;

    return (
      <div>
        <div className="main-container default-page mt-5 pt-5">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Weekly Ads</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/weekly-ads">Weekly Ads</a>
                        </li>
                        <li>
                          <span className="active">
                            {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                          </span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">
                    {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                  </h1>
                </header>
                <div className="breadcrumbs d-none d-md-block ">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> Weekly Ads</span>
                </div>
              </div>
            </div>
          )}
          <div className="clearfix" />
          <div className="container">
            <div className="row" style={{ minHeight: "600px" }}>
              <div className="col-xs-12 ">
                <div className="page-content default-page">
                  <article
                    id="post-8027"
                    className="post-8027 page type-page status-publish hentry"
                  >
                    <div className="entry-content mt-5">
                      <div className="vc_row wpb_row vc_row-fluid">
                        <div className="row-container">
                          {this.state.WeeklyAds &&
                          this.state.WeeklyAds.length > 0 ? (
                            this.state.WeeklyAds.map((WeeklyAd, index) => (
                              <div
                                key={index}
                                className="wpb_column vc_column_container vc_col-sm-3"
                                style={{ minWidth: "290px" }}
                              >
                                <div className="vc_column-inner">
                                  <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_center">
                                      <figure className="wpb_wrapper vc_figure profile-img-container">
                                        <a
                                          onClick={() =>
                                            this.setState({
                                              isOpen: true,
                                              adindex: index,
                                            })
                                          }
                                          href="javascript:void(0)"
                                          className="vc_single_image-wrapper   vc_box_border_grey"
                                        >
                                          <img
                                            width={1575}
                                            height={1500}
                                            src={WeeklyAd.URL}
                                            className="vc_single_image-img attachment-full"
                                            alt={
                                              "Weekly Ads at " + WeeklyAd.URL
                                            }
                                          />
                                        </a>
                                      </figure>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : this.state.WeeklyAds ? (
                            <div className="content">
                              <div className="overlay">
                                <div className="overlay-content">
                                  <div style={{ height: "200px" }}></div>
                                  <h3>No Weekly Ads found</h3>
                                  <div style={{ height: "100px" }}></div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="content">
                              <div className="overlay">
                                <div className="overlay-content">
                                  <div style={{ height: "100px" }}></div>
                                  <img
                                    style={{ maxWidth: "none" }}
                                    src="/assets/images/loading.gif"
                                    alt="Loading..."
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={this.state.WeeklyAds[adindex].URL}
            nextSrc={
              this.state.WeeklyAds[(adindex + 1) % this.state.WeeklyAds.length]
            }
            prevSrc={
              this.state.WeeklyAds[
                (adindex + images.length - 1) % this.state.WeeklyAds.length
              ]
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                adindex:
                  (adindex + this.state.WeeklyAds.length - 1) %
                  this.state.WeeklyAds.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                adindex: (adindex + 1) % this.state.WeeklyAds.length,
              })
            }
          />
        )}
      </div>
    );
  }
}
export default Weeklyadsall;
